// Backend conversation timestamps are UTC, but some endpoints serialize them
// without a timezone suffix (Python str(datetime)). Treat timezone-less
// date-time strings as UTC so timeline positions match the rest of the app.
export const parseBackendDateMs = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;

  const text = String(value).trim();
  if (!text) return null;

  const numeric = Number(text);
  if (Number.isFinite(numeric)) return numeric;

  const hasExplicitZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(text);
  const hasTime = /^\d{4}-\d{2}-\d{2}[T\s]\d{1,2}:\d{2}/.test(text);
  const normalized = hasTime && !hasExplicitZone ? `${text}Z` : text;
  const ms = new Date(normalized).getTime();
  return Number.isFinite(ms) ? ms : null;
};
